import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0590360a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../styles/normalize.css?vue&type=style&index=0&lang=scss&"
import style1 from "../styles/_base.scss?vue&type=style&index=1&lang=scss&"
import style2 from "../styles/_dailog.scss?vue&type=style&index=2&lang=scss&"
import style3 from "../styles/select.scss?vue&type=style&index=3&lang=css&"
import style4 from "swiper/dist/css/swiper.css?vue&type=style&index=4&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0590360a')) {
      api.createRecord('0590360a', component.options)
    } else {
      api.reload('0590360a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0590360a&", function () {
      api.rerender('0590360a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/index.vue"
export default component.exports